import { action, computed, observable, runInAction, makeObservable } from 'mobx';
import { get, post, requests, patch } from '@partsbadger/utils';

import { IRequirement, IAdditionalRequirementByContact } from '@partsbadger/types';

class AdditionalRequirementStore {
    additionalRequirements: Array<IRequirement> = [];
    additionalRequirementsByContact: IAdditionalRequirementByContact[] = [];

    constructor() {
        makeObservable(this, {
            additionalRequirements: observable,
            additionalRequirementsByContact: observable,

            getAdditionalRequirements: action,
            getAdditionalRequirementsByContact: action,
        });
    }

    getAdditionalRequirements = () => {
        get(`/customer/additional-requirements/`).then(data => {
            runInAction(() => {
                this.additionalRequirements = data.results;
            });
        });
    };

    getAdditionalRequirementsByContact = (contactId: number) => {
        get(`/customer/contacts/${contactId}/additional-requirements/`).then(data => {
            runInAction(() => {
                this.additionalRequirementsByContact = data.results;
            });
        });
    };
}

const additionalRequirementStore = new AdditionalRequirementStore();

export default additionalRequirementStore;
